<script>
    import ListMap from '@js/components/maps/ListMap.svelte';

    const {
        initialLocation,
        searchParams
    } = $props();
</script>

<ListMap mapId="place-show-rides"
         initialLocation={initialLocation}
         searchOnZoom={true}
         searchParams={searchParams}/>
